import { InstallReducer } from "@web-monorepo/shared/podInfra";
import { Saga } from "redux-saga";
import { LOG_EVENT, logEvent, logEventSaga } from "./data/logEvent";

export { LOG_EVENT, logEvent };

export default function installer(_: InstallReducer, installSaga: (saga: Saga) => void) {
  installSaga(logEventSaga);
}
